var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNorthEast(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99917 4.49967C5.99917 4.87301 6.29917 5.16634 6.66583 5.16634H10.3925L3.1325 12.4263C2.8725 12.6863 2.8725 13.1063 3.1325 13.3663C3.3925 13.6263 3.8125 13.6263 4.0725 13.3663L11.3325 6.10634V9.83301C11.3325 10.1997 11.6325 10.4997 11.9992 10.4997C12.3658 10.4997 12.6658 10.1997 12.6658 9.83301V4.49967C12.6658 4.13301 12.3658 3.83301 11.9992 3.83301H6.66583C6.29917 3.83301 5.99917 4.13301 5.99917 4.49967Z",
    fill: "#FF006A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNorthEast);
export default __webpack_public_path__ + "static/media/north_east.f14b95ff6992f0cec859b31fc2977f20.svg";
export { ForwardRef as ReactComponent };